import axios from 'axios';

// Contact 页面提交给 Netlify Function，由服务端读取 SMTP 环境变量发送邮件。
export function sendContactEmail(email) {
  return axios.post('/meaning/functions/send-contact-email', { email });
}
